import * as React from "react";
import { css, cx } from "emotion";
import { getThemeColorVar } from "../helper/color";
function dividerClass(height, drawBorder) {
    return css({
        minHeight: `${height}px`,
        height: `${height}px`,
        borderLeft: drawBorder
            ? `1px solid ${getThemeColorVar("border", "default")}`
            : "none",
        marginLeft: "3px",
        marginRight: "4px",
    });
}
export const HorizontalDivider = (props) => {
    return React.createElement("div", { className: cx(dividerClass(props.height, !props.borderless)) });
};
export default HorizontalDivider;
//# sourceMappingURL=horizontaldivider.js.map